import { render, staticRenderFns } from "./KagnotList.vue?vue&type=template&id=7470e9e6&scoped=true"
import script from "./KagnotList.vue?vue&type=script&lang=js"
export * from "./KagnotList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7470e9e6",
  null
  
)

export default component.exports